module.exports = __webpack_public_path__ + "assets/img/projects_item11.0991221a.png";